import React from "react";
import ReactDOM from "react-dom/client";
import App from "./modules/chat-app";
import "./index.css";

// Initialize viewport polyfill for dvh support
import "./lib/viewport-polyfill";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
